import { ExportSection } from '../types';
import { isStringExportColumn } from './isStringExportColumn';
import resolveMaxLengthIssue from './resolveMaxLengthIssue';

// Mirrors the hasExportableColumns gating: only columns that actually reach the file can block the export.
const hasInvalidMaxLength = (sections: ExportSection[]): boolean =>
  sections.some(
    (section) =>
      section.enabled &&
      section.columns.some(
        (column) =>
          column.selected &&
          isStringExportColumn(column) &&
          resolveMaxLengthIssue(column.exportOptions.maxLength) !== null
      )
  );

export default hasInvalidMaxLength;
